import { User } from '@nextforce/api'
import { makeStyles, Text, useTheme } from '@rneui/themed'
import { t } from 'app/i18l'
import { font } from 'app/theme'
import { View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { Card } from 'shared/components/card'
import { GoldStar } from 'shared/components/gold_star'
import { RoundedButton } from 'shared/components/rounded-button'

const CARD_HEIGHT = 100

interface GoldStarsViewProps {
  user?: User
  onPressTransfer: () => void
  onPressViewTransactions: () => void
}

export function GoldStarsView({
  user,
  onPressTransfer,
  onPressViewTransactions,
}: GoldStarsViewProps) {
  const { theme } = useTheme()
  const styles = useStyles(theme)

  if (!user) {
    return null
  }

  return (
    <SafeAreaView edges={['left', 'right', 'bottom']} style={styles.root}>
      <View style={styles.container}>
        <View style={styles.innerContainer}>
          <Card style={styles.card}>
            <View style={styles.headingContainer}>
              <Text style={styles.heading}>{t('goldStarsAvailable')}</Text>
              <View style={styles.goldStarsContainer}>
                <Text style={styles.innerHeading}>{user?.goldStars ?? 0}</Text>
                <GoldStar size={24} />
                <Text style={styles.innerHeading}>Stars</Text>
              </View>
            </View>
          </Card>

          <RoundedButton
            title={t('transferGoldStars')}
            danger
            onPress={onPressTransfer}
            buttonStyle={styles.buttonStyle}
          />
          <RoundedButton
            title={t('transactionLog')}
            onPress={onPressViewTransactions}
            buttonStyle={styles.buttonStyle}
          />
        </View>
      </View>
    </SafeAreaView>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    flex: 1,
  },
  container: {
    flex: 1,
    padding: 10,
    backgroundColor: theme.colors?.grey5,
  },
  innerContainer: {
    margin: 10,
  },
  card: {
    height: CARD_HEIGHT,
  },
  headingContainer: {
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  heading: {
    fontSize: 20,
    fontFamily: font.bold,
    margin: 5,
    marginBottom: 10,
  },
  innerHeading: {
    fontSize: 18,
    marginHorizontal: 5,
  },
  buttonStyle: {
    margin: 5,
    marginTop: 15,
  },
  goldStarsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    margin: 5,
    marginTop: 10,
  },
}))
